export default {
  ckErr: () => {
    try {
      console.log("TRY");
    } catch (err) {
      console.log("catch");
    }
  },
  monthTh: [
    "ม.ค.",
    "ก.พ.",
    "มี.ค.",
    "เม.ย.",
    "พ.ค.",
    "มิ.ย.",
    "ก.ค.",
    "ส.ค.",
    "ก.ย.",
    "ต.ค.",
    "พ.ย.",
    "ธ.ค."
  ],
  cutFileName(value) {
    value = value.split("attachment;")[1];
    value = value.split("=")[1];
    value = value.split('"')[1];
    return value;
  },
  calcDate(date, days) {
    var result = date; // not instatiated with date!!! DANGER
    result.setDate(date.getDate() - days);
    return result;
  }
};
